// Domain · GdStatusChip helpers
//
// Tone + label resolution for the `price_lists.gd_status` enum.
// Split out of `GdStatusChip.tsx` so that module exports components only.

import type { PillTone } from "@ds/display/Pill";
import { GD_STATUS_COLORS } from "@ds/tokens/domainTones";

export type GdStatus = "yes" | "no" | "na";

// Polish BDO domain shorthand:
//   yes → GD  (Gospodarka Domowa — household waste)
//   no  → IŹ  (Inne Źródła — non-household / industrial)
//   na  → NA  (not applicable / unknown)
// These are the labels used on every BDO scrape and across price-lists +
// EDPR requests + transactions. Generic "Tak/Nie/N/D" was ambiguous —
// "GD/IŹ" tells the reader the classification, not just the answer.
const GD_STATUS_TEXT: Record<GdStatus, string> = {
  yes: "GD",
  no:  "IŹ",
  na:  "NA",
};

/** Resolve a GD status to its canonical `PillTone`. Returns `"grey"` for null/unknown. */
export function gdStatusTone(status: GdStatus | null | undefined): PillTone {
  if (!status) return "grey";
  return (GD_STATUS_COLORS[status]) ?? "grey";
}

/** Resolve a GD status to its canonical Polish label. Returns `null` for null/unknown. */
export function gdStatusText(status: GdStatus | null | undefined): string | null {
  if (!status) return null;
  return GD_STATUS_TEXT[status] ?? null;
}
